import { useEffect, useState } from "react";

const FlashSaleBar = ({ title = "FLASH SALE" }) => {
  const [time, setTime] = useState({
    hours: 2,
    minutes: 30,
    seconds: 0,
  });

  useEffect(() => {
    const timer = setInterval(() => {
      setTime((prev) => {
        let { hours, minutes, seconds } = prev;

        if (seconds > 0) {
          seconds--;
        } else {
          if (minutes > 0) {
            minutes--;
            seconds = 59;
          } else if (hours > 0) {
            hours--;
            minutes = 59;
            seconds = 59;
          }
        }

        return { hours, minutes, seconds };
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="bg-gradient-to-r from-red-600 to-orange-500 dark:from-red-700 dark:to-orange-600 text-white py-2 shadow-lg">
      <div className="max-w-7xl mx-auto flex items-center gap-6 px-4">
        {/* Flash Sale + Timer */}
        <div className="flex items-center gap-2 sm:gap-3 font-black whitespace-nowrap">
          <span className="text-xs sm:text-base drop-shadow-[0_2px_2px_rgba(0,0,0,0.5)]">
            🔥 {title.toUpperCase()}
          </span>

          <div className="flex gap-1 text-[10px] sm:text-sm">
            <span className="bg-black px-1.5 py-0.5 sm:px-2 sm:py-1 rounded">
              {String(time.hours).padStart(2, "0")}
            </span>
            :
            <span className="bg-black px-1.5 py-0.5 sm:px-2 sm:py-1 rounded">
              {String(time.minutes).padStart(2, "0")}
            </span>
            :
            <span className="bg-black px-1.5 py-0.5 sm:px-2 sm:py-1 rounded">
              {String(time.seconds).padStart(2, "0")}
            </span>
          </div>
        </div>

        {/* Marquee */}
        <div className="flex-1 overflow-hidden">
          <div className="animate-marquee whitespace-nowrap">
            Nike Dunk -30% &nbsp;&nbsp;&nbsp; Adidas Campus -25%
            &nbsp;&nbsp;&nbsp; Air Force 1 -20% &nbsp;&nbsp;&nbsp; Puma Speed
            Cat -15% &nbsp;&nbsp;&nbsp; Rick Owens -10%
          </div>
        </div>
      </div>
    </div>
  );
};

export default FlashSaleBar;
